import moment from 'moment'

const getOptions = ({
    categories,
    maxValue,
    safeMinimumUsableStock = 5,
    theme,
}: {
    categories: string[],
    maxValue: number,
    safeMinimumUsableStock: number,
    theme: Record<string, any>,
}) => {
    const defineColor = ({
        value,
    }) => {
        return value > safeMinimumUsableStock
            ? theme.palette.primary[200]
            : theme.palette.common.red
    }

    return {
        legend: {
            horizontalAlign: 'left',
        } as ApexLegend,
        chart: {
            id: 'basic-bar',
            toolbar: {
                show: true,
                offsetX: -60,
                offsetY: 0,
                tools: {
                    download: '<img src="/assets/images/download_button.svg" width="24px" height="24px" alt="download"/>',
                },
            },
        },
        tooltip: {
            enabled: false,
        },
        yaxis: {
            max: maxValue + 2,
            min: 0,
            labels: {
                formatter(val) {
                    return val.toFixed(0)
                },
            },
        },
        xaxis: {
            categories,
            labels: {
                formatter(value) {
                    return moment(value, 'DD.MM.YYYY').format('DD.MM')
                },
            },
        },
        colors: [defineColor],
        plotOptions: {
            bar: {
                dataLabels: {
                    position: 'top',
                },
            },
        },
        dataLabels: {
            offsetY: -20,
            formatter(val) {
                return val === 0 ? '' : val
            },
            enabled: true,
            style: {
                fontSize: '12px',
                colors: ['grey'],
            },
        },
        grid: {
            padding: {
                right: 70,
                top: 20,
            },
            xaxis: {
                lines: {
                    show: true,
                },
            },
            strokeDashArray: 7,
        },
        annotations: {
            yaxis: [{
                y: safeMinimumUsableStock,
                strokeDashArray: 10,
                borderColor: theme.palette.primary[600],
                label: {
                    style: {
                        fontSize: '15px',
                        color: theme.palette.primary[600],
                        background: 'none',
                    },
                    offsetX: 60,
                    textAnchor: 'end',
                    borderWidth: 0,
                    text: [
                        'Safe Min',
                        'Usable',
                        'Stock',
                    ],
                },
            }],
        },
    }
}

export default getOptions
